const campaignMapping = [
  { label: "Main MFC Campagin", value: "default" },
  { label: "Liberia", value: "liberia" },
  { label: "Bolivia", value: "bolivia" },
  { label: "Tanzania", value: "tanzania" },
  { label: "Kenya", value: "kenya" },
  { label: "Ghana", value: "ghana" },
  { label: "Mexico", value: "mexico" },
  { label: "United States", value: "united-states" },
  { label: "Nepal", value: "nepal" },
  { label: "Laos", value: "laos" },
  { label: "Timor-Leste", value: "timor-leste" },
  { label: "Papua New Guinea", value: "papua-new-guinea" },
  { label: "Comoros", value: "comoros" },
  { label: "Mauritania", value: "mauritania" },
  { label: "Malawi", value: "malawi" },
  { label: "Lesotho", value: "lesotho" },
  { label: "Benin", value: "benin" },
  { label: "Togo", value: "togo" },
  { label: "Guinea-Bissau", value: "guinea-bissau" },
  { label: "Sierra Leone", value: "sierra-leone" },
  { label: "Guinea", value: "guinea" },
  { label: "Angola", value: "angola" },
  { label: "Zimbabwe", value: "zimbabwe" },
  { label: "Zambia", value: "zambia" },
  { label: "Madagascar", value: "madagascar" },
  { label: "Eritrea", value: "eritrea" },
  { label: "Burundi", value: "burundi" },
  { label: "Bangladesh", value: "bangladesh" },
  { label: "Pakistan", value: "pakistan" },
  { label: "Lebanon", value: "lebanon" },
  { label: "Nigeria", value: "nigeria" },
  { label: "Congo", value: "congo" },
  { label: "Cameroon", value: "cameroon" },
  { label: "Mozambique", value: "mozambique" },
  { label: "Libya", value: "libya" },
  { label: "Yemen", value: "yemen" },
  { label: "Jamaica", value: "jamaica" },
  { label: "Venezuela", value: "venezuela" },
  { label: "Ukraine", value: "ukraine" },
  { label: "Syria", value: "syria" },
  { label: "Sudan", value: "sudan" },
  { label: "South Sudan", value: "south-sudan" },
  { label: "Somalia", value: "somalia" },
  { label: "Niger", value: "niger" },
  { label: "Myanmar", value: "myanmar" },
  { label: "Mali", value: "mali" },
  { label: "Haiti", value: "haiti" },
  { label: "Ethiopia", value: "ethiopia" },
  { label: "Democratic Republic of the Congo", value: "democratic-republic-of-the-congo" },
  { label: "Chad", value: "chad" },
  { label: "Central African Republic", value: "central-african-republic" },
  { label: "Burkina Faso", value: "burkina-faso" },
  { label: "Afghanistan", value: "afghanistan" },
  { label: "Palestine", value: "palestine" }
];

export default campaignMapping